
import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Box, useTheme } from "@material-ui/core";
import DataService from "../../../../Service";

function ProgramRateDetails() {
  const classes = useStyles();
  const [programmeRate, setProgrammeRate] = useState([]);
  const [assignmentName, setassignmentName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [sepecifiedelemetPrice, setSpecifiedelemetPrice] = useState("");
  const [coachingPgmPrice, setCoachingPgmPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [addOns,setAddOns]=useState([]);

  let urlElements = window.location.href.split('/');
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID
    }
    DataService.getDirectData(`/invoices/programme_rate_details`, params).then((response) => {

      setProgrammeRate(response.programme_rate)
      setassignmentName(response.assignment_name)
      setOrgName(response.organisation_name)
      setSpecifiedelemetPrice(response.payment_terms)
      setCoachingPgmPrice(response.total_amount)
      setAddOns(response.add_ons.filter((el)=>el.label!==null))
      setLoading(false);
    })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Box mb="30px">
        <Typography className={classes.heading}>
          Program rate includes
        </Typography>
        {programmeRate.length > 0 && programmeRate.map((item) => (
          <Typography key={item} className={classes.bodyText}>
            {item}
          </Typography>
        ))}
      </Box>

      <Box>
        <Typography className={classes.heading}>Add-ons</Typography>
        {addOns.map((item) => (
          <Typography key={item} className={classes.bodyText}>
            {item.label}
          </Typography>
        ))}
      </Box>
    </div>
  );
}

export default ProgramRateDetails;

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 14,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    marginBottom: 20,
  },
  bodyText: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#232323",
    marginBottom: 14,
  },
}));
